const properties = [
  {
    reference: "RS47946",
    title: "Luxury Terraced Duplex in Ikeja GRA",
    advert: "for-rent",
    propertyType: "Duplex",
    location: "13, Adetokunbo Street, GRA",
    city: "ikeja",
    state: "Lagos",
    description:
      "A luxury 3-bedroom terraced duplex located in a serene neighborhood with ample parking and 24/7 security.",
    noOfUnits: "1",
    bedroom: "3",
    bathroom: "4",
    toilets: "4",
    totalArea: null,
    propertyUse: "Residential",
    yearBuilt: "2022",
    marketStatus: "Available",
    price: 5000000,
    dateAdded: "03-Jul-2025",
    lastUpdated: "20 days ago",
    marketer: "Prime Estates",
    photos: [
      "/images/properties/house/house-1.jpg",
      "/images/properties/house/house-1-1.jpg",
      "/images/properties/house/house-1-2.jpg",
      "/images/properties/house/house-1-3.jpg",
      "/images/properties/house/house-1-4.jpg",
      "/images/properties/bathroom/bathroom-1.jpg",
      "/images/properties/toilet/toilet-1.jpg",
    ],
  },
  {
    reference: "RS56320",
    title: "Modern Furnished Shortlet in Asokoro",
    advert: "short-let",
    propertyType: "Flat Apartment",
    location: "5, Asokoro Avenue",
    city: "Abuja",
    state: "FCT",
    description:
      "Modern shortlet apartment close to the city center with premium furnishing and fast Wi-Fi.",
    noOfUnits: "2",
    bedroom: "2",
    bathroom: "2",
    toilets: "2",
    totalArea: null,
    propertyUse: "Residential",
    yearBuilt: "2021",
    marketStatus: "Available",
    price: 1500000,
    dateAdded: "11-Jul-2025",
    lastUpdated: "12 days ago",
    marketer: "John Doe Estates",
    photos: [
      "/images/properties/house/house-2.jpg",
      "/images/properties/house/house-2-1.jpg",
      "/images/properties/house/house-2-2.jpg",
      "/images/properties/house/house-2-3.jpg",
      "/images/properties/house/house-2-4.jpg",
      "/images/properties/bathroom/bathroom-2.jpg",
      "/images/properties/toilet/toilet-2.jpg",
    ],
  },
  {
    reference: "RS10082",
    title: "3-Bedroom Detached Bungalow in Ilorin",
    advert: "for-sale",
    propertyType: "Bungalow",
    location: "17, Awolowo Street",
    city: "Ilorin",
    state: "Kwara",
    description:
      "A spacious and fully fenced 3-bedroom bungalow with tiled floors and ample compound space.",
    noOfUnits: "1",
    bedroom: "3",
    bathroom: "3",
    toilets: "3",
    totalArea: null,
    propertyUse: "Residential",
    yearBuilt: "2018",
    marketStatus: "Available",
    price: 3500000,
    dateAdded: "29-Jun-2025",
    lastUpdated: "24 days ago",
    marketer: "Jane Smith Realty",
    photos: [
      "/images/properties/house/house-3.jpg",
      "/images/properties/house/house-3-1.jpg",
      "/images/properties/house/house-3-2.jpg",
      "/images/properties/house/house-3-3.jpg",
      "/images/properties/house/house-3-4.jpg",
      "/images/properties/bathroom/bathroom-3.jpg",
      "/images/properties/toilet/toilet-3.jpg",
    ],
  },
  {
    reference: "LD73212",
    title: "60 Acres of Dry Land in Port Harcourt",
    advert: "for-sale",
    propertyType: "land",
    location: "New Layout, Airport Road",
    city: "Port Harcourt",
    state: "Rivers",
    description:
      "Dry and level land, 60 acres, ideal for estate development. Full documentation available.",
    noOfUnits: "N/A",
    bedroom: null,
    bathroom: null,
    toilets: null,
    totalArea: "60 acres",
    propertyUse: "Residential",
    yearBuilt: "N/A",
    marketStatus: "Available",
    price: 120000000,
    dateAdded: "02-Jul-2025",
    lastUpdated: "21 days ago",
    marketer: "Estate Masters Ltd",
    photos: ["images/properties/land/land-1.jpg"],
  },
  {
    reference: "LD67590",
    title: "1 Acre Land for Agricultural Lease in Ife",
    advert: "for-rent",
    propertyType: "land",
    location: "Behind OAU Teaching Hospital",
    city: "Ile-Ife",
    state: "Osun",
    description:
      "A fenced plot of land available for agricultural lease. Quiet and secure environment.",
    noOfUnits: "N/A",
    bedroom: null,
    bathroom: null,
    toilets: null,
    totalArea: "1 acre",
    propertyUse: "Residential",
    yearBuilt: "N/A",
    marketStatus: "Available",
    price: 500000,
    dateAdded: "01-Jul-2025",
    lastUpdated: "22 days ago",
    marketer: "Estate Masters Ltd",
    photos: ["images/properties/land/land-2.jpg"],
  },
  {
    reference: "RS90114",
    title: "Mini Flat for Shortlet in Gudu District",
    advert: "short-let",
    propertyType: "Flat",
    location: "Zaram Close, Gudu District",
    city: "Abuja",
    state: "FCT",
    description:
      "Cozy mini flat ideal for working professionals. Close to main road and shopping centers.",
    noOfUnits: "3",
    bedroom: "1",
    bathroom: "1",
    toilets: "2",
    totalArea: null,
    propertyUse: "Residential",
    yearBuilt: "2023",
    marketStatus: "Available",
    price: 800000,
    dateAdded: "05-Jul-2025",
    lastUpdated: "18 days ago",
    marketer: "Luxury Homes Abuja",
    photos: [
      "/images/properties/house/house-4.jpg",
      "/images/properties/house/house-4-1.jpg",
      "/images/properties/house/house-4-2.jpg",
      "/images/properties/house/house-4-3.jpg",
      "/images/properties/house/house-4-4.jpg",
      "/images/properties/bathroom/bathroom-4.jpg",
      "/images/properties/toilet/toilet-4.jpg",
    ],
  },
  {
    reference: "MS45210",
    title: "Luxury 6-Bedroom Mansion in Banana Island",
    advert: "for-sale",
    propertyType: "Mansion",
    location: "Plot 14, Banana Island Road",
    city: "Ikoyi",
    state: "Lagos",
    description:
      "Ultra-modern 6-bedroom mansion with smart home features, swimming pool, cinema, and rooftop lounge.",
    noOfUnits: "1",
    bedroom: "6",
    bathroom: "7",
    toilets: "8",
    totalArea: "1500 sqm",
    propertyUse: "Residential",
    yearBuilt: "2023",
    marketStatus: "Available",
    price: 950000000,
    dateAdded: "05-Jul-2025",
    lastUpdated: "18 days ago",
    marketer: "Prime Realtors NG",
    photos: [
      "/images/properties/house/house-5.jpg",
      "/images/properties/house/house-5-1.jpg",
      "/images/properties/house/house-5-2.jpg",
      "/images/properties/house/house-5-3.jpg",
      "/images/properties/house/house-5-4.jpg",
      "/images/properties/bathroom/bathroom-5.jpg",
      "/images/properties/toilet/toilet-5.jpg",
    ],
  },
  {
    reference: "HT90833",
    title: "40-Room Luxury Hotel in Victoria Island",
    advert: "for-sale",
    propertyType: "Hotel",
    location: "245 Adeola Odeku Street",
    city: "Victoria Island",
    state: "Lagos",
    description:
      "Fully operational luxury hotel with bar, lounge, conference hall, and ample parking.",
    noOfUnits: "40",
    bedroom: "40",
    bathroom: "42",
    toilets: "45",
    totalArea: "3200 sqm",
    propertyUse: "Commercial",
    yearBuilt: "2016",
    marketStatus: "Available",
    price: 1800000000,
    dateAdded: "01-Jul-2025",
    lastUpdated: "22 days ago",
    marketer: "BlueGold Properties",
    photos: [
      "/images/properties/house/house-6.jpg",
      "/images/properties/house/house-6-1.jpg",
      "/images/properties/house/house-6-2.jpg",
      "/images/properties/house/house-6-3.jpg",
      "/images/properties/house/house-6-4.jpg",
      "/images/properties/bathroom/bathroom-6.jpg",
      "/images/properties/toilet/toilet-6.jpg",
    ],
  },
  {
    reference: "BG60211",
    title: "2-Bedroom Bungalow in Abeokuta",
    advert: "for-sale",
    propertyType: "Bungalow",
    location: "Behind Olumo Estate",
    city: "Abeokuta",
    state: "Ogun",
    description:
      "Cozy 2-bedroom bungalow in a gated estate with borehole water supply and secured environment.",
    noOfUnits: "1",
    bedroom: "2",
    bathroom: "2",
    toilets: "3",
    totalArea: "450 sqm",
    propertyUse: "Residential",
    yearBuilt: "2020",
    marketStatus: "Available",
    price: 15000000,
    dateAdded: "10-Jul-2025",
    lastUpdated: "12 days ago",
    marketer: "Olumo Homes",
    photos: [
      "/images/properties/house/house-7.jpg",
      "/images/properties/house/house-7-1.jpg",
      "/images/properties/house/house-7-2.jpg",
      "/images/properties/house/house-7-3.jpg",
      "/images/properties/house/house-7-4.jpg",
      "/images/properties/bathroom/bathroom-7.jpg",
      "/images/properties/toilet/toilet-7.jpg",
    ],
  },
  {
    reference: "DX22119",
    title: "4-Bedroom Duplex in Enugu",
    advert: "for-sale",
    propertyType: "Duplex",
    location: "Independence Layout, Phase 2",
    city: "Enugu",
    state: "Enugu",
    description:
      "Spacious duplex with modern fittings, POP ceilings, tiled floors, and a large kitchen.",
    noOfUnits: "1",
    bedroom: "4",
    bathroom: "4",
    toilets: "5",
    totalArea: "600 sqm",
    propertyUse: "Residential",
    yearBuilt: "2021",
    marketStatus: "Available",
    price: 45000000,
    dateAdded: "08-Jul-2025",
    lastUpdated: "15 days ago",
    marketer: "Eastern Real Estate",
    photos: [
      "/images/properties/house/house-8.jpg",
      "/images/properties/house/house-8-1.jpg",
      "/images/properties/house/house-8-2.jpg",
      "/images/properties/house/house-8-3.jpg",
      "/images/properties/house/house-8-4.jpg",
      "/images/properties/bathroom/bathroom-8.jpg",
      "/images/properties/toilet/toilet-8.jpg",
    ],
  },
  {
    reference: "FL77124",
    title: "2-Bedroom Flat in Surulere",
    advert: "for-rent",
    propertyType: "Flat",
    location: "Alhaji Masha Road",
    city: "Surulere",
    state: "Lagos",
    description:
      "Neatly finished 2-bedroom flat with modern kitchen, wardrobes, and prepaid meter.",
    noOfUnits: "1",
    bedroom: "2",
    bathroom: "2",
    toilets: "2",
    totalArea: null,
    propertyUse: "Residential",
    yearBuilt: "2019",
    marketStatus: "Available",
    price: 1200000,
    dateAdded: "06-Jul-2025",
    lastUpdated: "17 days ago",
    marketer: "CityHomes NG",
    photos: [
      "/images/properties/house/house-9.jpg",
      "/images/properties/house/house-9-1.jpg",
      "/images/properties/house/house-9-2.jpg",
      "/images/properties/house/house-9-3.jpg",
      "/images/properties/house/house-9-4.jpg",
      "/images/properties/bathroom/bathroom-9.jpg",
      "/images/properties/toilet/toilet-9.jpg",
    ],
  },
  {
    reference: "LD93012",
    title: "10 Acres of Farm Land in Ibadan",
    advert: "for-rent",
    propertyType: "Land",
    location: "Moniya Area",
    city: "Ibadan",
    state: "Oyo",
    description:
      "10 acres of fertile farmland suitable for mechanized farming. Accessible road and survey plan available.",
    noOfUnits: "N/A",
    bedroom: null,
    bathroom: null,
    toilets: null,
    totalArea: "10 acres",
    propertyUse: "Agricultural",
    yearBuilt: "N/A",
    marketStatus: "Available",
    price: 3500000,
    dateAdded: "03-Jul-2025",
    lastUpdated: "20 days ago",
    marketer: "GreenFields Realty",
    photos: ["/images/properties/land/land-3.jpg"],
  },
  {
    reference: "DX82034",
    title: "5-Bedroom Duplex in Abuja",
    advert: "for-rent",
    propertyType: "Duplex",
    location: "Gwarinpa Estate",
    city: "Abuja",
    state: "FCT",
    description:
      "A modern duplex with large compound, BQ, fitted kitchen, and solar backup system.",
    noOfUnits: "1",
    bedroom: "5",
    bathroom: "5",
    toilets: "6",
    totalArea: "700 sqm",
    propertyUse: "Residential",
    yearBuilt: "2022",
    marketStatus: "Available",
    price: 8000000,
    dateAdded: "11-Jul-2025",
    lastUpdated: "10 days ago",
    marketer: "Capital Homes Ltd",
    photos: [
      "/images/properties/house/house-10.jpg",
      "/images/properties/house/house-10-1.jpg",
      "/images/properties/house/house-10-2.jpg",
      "/images/properties/house/house-10-3.jpg",
      "/images/properties/house/house-10-4.jpg",
      "/images/properties/bathroom/bathroom-10.jpg",
      "/images/properties/toilet/toilet-10.jpg",
    ],
  },
  {
    reference: "MS22344",
    title: "7-Bedroom Mansion in Lekki",
    advert: "for-sale",
    propertyType: "Mansion",
    location: "Chevron Drive, Lekki",
    city: "Lekki",
    state: "Lagos",
    description:
      "Exquisite 7-bedroom mansion with two living rooms, gym, pool, and security house.",
    noOfUnits: "1",
    bedroom: "7",
    bathroom: "8",
    toilets: "9",
    totalArea: "1100 sqm",
    propertyUse: "Residential",
    yearBuilt: "2023",
    marketStatus: "Available",
    price: 650000000,
    dateAdded: "07-Jul-2025",
    lastUpdated: "16 days ago",
    marketer: "Luxury Haven Realty",
    photos: [
      "/images/properties/house/house-11.jpg",
      "/images/properties/house/house-11-1.jpg",
      "/images/properties/house/house-11-2.jpg",
      "/images/properties/house/house-11-3.jpg",
      "/images/properties/house/house-11-4.jpg",
      "/images/properties/bathroom/bathroom-11.jpg",
      "/images/properties/toilet/toilet-11.jpg",
    ],
  },
  {
    reference: "FL50192",
    title: "1-Bedroom Mini Flat in Yaba",
    advert: "for-rent",
    propertyType: "Flat",
    location: "Herbert Macaulay Way",
    city: "Yaba",
    state: "Lagos",
    description:
      "Affordable 1-bedroom mini flat with open kitchen, tiled floors, and 24/7 water supply.",
    noOfUnits: "1",
    bedroom: "1",
    bathroom: "1",
    toilets: "1",
    totalArea: null,
    propertyUse: "Residential",
    yearBuilt: "2017",
    marketStatus: "Available",
    price: 500000,
    dateAdded: "09-Jul-2025",
    lastUpdated: "13 days ago",
    marketer: "Metro Properties",
    photos: [
      "/images/properties/house/house-12.jpg",
      "/images/properties/house/house-12-1.jpg",
      "/images/properties/house/house-12-2.jpg",
      "/images/properties/house/house-12-3.jpg",
      "/images/properties/house/house-12-4.jpg",
      "/images/properties/bathroom/bathroom-12.jpg",
      "/images/properties/toilet/toilet-12.jpg",
    ],
  },
  {
    reference: "HT60078",
    title: "25-Room Hotel in Owerri",
    advert: "for-sale",
    propertyType: "Hotel",
    location: "Wetheral Road",
    city: "Owerri",
    state: "Imo",
    description:
      "Functioning 25-room hotel with restaurant, bar, ample parking, and full documents.",
    noOfUnits: "25",
    bedroom: "25",
    bathroom: "27",
    toilets: "30",
    totalArea: "2200 sqm",
    propertyUse: "Commercial",
    yearBuilt: "2015",
    marketStatus: "Available",
    price: 600000000,
    dateAdded: "04-Jul-2025",
    lastUpdated: "19 days ago",
    marketer: "Eastern Hospitality Realtors",
    photos: [
      "/images/properties/house/house-13.jpg",
      "/images/properties/house/house-13-1.jpg",
      "/images/properties/house/house-13-2.jpg",
      "/images/properties/house/house-13-3.jpg",
      "/images/properties/house/house-13-4.jpg",
      "/images/properties/bathroom/bathroom-13.jpg",
      "/images/properties/toilet/toilet-13.jpg",
    ],
  },
  {
    reference: "LD90123",
    title: "5 Plots of Fenced Land in Gwagwalada",
    advert: "for-sale",
    propertyType: "Land",
    location: "Opposite University Gate",
    city: "Abuja",
    state: "FCT",
    description:
      "Well-positioned 5 plots of fenced land with easy access to the main express road.",
    noOfUnits: "N/A",
    bedroom: null,
    bathroom: null,
    toilets: null,
    totalArea: "5 plots",
    propertyUse: "Residential",
    yearBuilt: "N/A",
    marketStatus: "Available",
    price: 15000000,
    dateAdded: "12-Aug-2025",
    lastUpdated: "2 days ago",
    marketer: "Prime Homes Nigeria",
    photos: ["/images/properties/land/land-4.jpg"],
  },
  {
    reference: "LD44567",
    title: "2 Hectares of Farmland in Ogbomosho",
    advert: "for-sale",
    propertyType: "Land",
    location: "Along Oyo-Ibadan Road",
    city: "Ogbomosho",
    state: "Oyo",
    description:
      "Fertile farmland measuring 2 hectares, suitable for agriculture and poultry.",
    noOfUnits: "N/A",
    bedroom: null,
    bathroom: null,
    toilets: null,
    totalArea: "2 hectares",
    propertyUse: "Agricultural",
    yearBuilt: "N/A",
    marketStatus: "Available",
    price: 7000000,
    dateAdded: "11-Aug-2025",
    lastUpdated: "3 days ago",
    marketer: "Greenfield Properties",
    photos: ["/images/properties/land/land-5.jpg"],
  },
  {
    reference: "LD55678",
    title: "Corner Plot at Lekki Phase 2",
    advert: "for-sale",
    propertyType: "Land",
    location: "Block C, Lekki Phase 2",
    city: "Lekki",
    state: "Lagos",
    description:
      "Dry corner plot measuring 650sqm in a serene gated community.",
    noOfUnits: "N/A",
    bedroom: null,
    bathroom: null,
    toilets: null,
    totalArea: "650 sqm",
    propertyUse: "Residential",
    yearBuilt: "N/A",
    marketStatus: "Available",
    price: 35000000,
    dateAdded: "10-Aug-2025",
    lastUpdated: "4 days ago",
    marketer: "Urban Living Realty",
    photos: ["/images/properties/land/land-6.jpg"],
  },
  {
    reference: "LD77889",
    title: "50 Acres Industrial Land in Ogun",
    advert: "for-sale",
    propertyType: "Land",
    location: "Sagamu Interchange",
    city: "Sagamu",
    state: "Ogun",
    description:
      "50 acres of industrial land close to Lagos-Ibadan expressway, perfect for factories.",
    noOfUnits: "N/A",
    bedroom: null,
    bathroom: null,
    toilets: null,
    totalArea: "50 acres",
    propertyUse: "Industrial",
    yearBuilt: "N/A",
    marketStatus: "Available",
    price: 80000000,
    dateAdded: "09-Aug-2025",
    lastUpdated: "5 days ago",
    marketer: "Apex Industrial Realty",
    photos: ["/images/properties/land/land-7.jpg"],
  },
  {
    reference: "LD33456",
    title: "Plot of Land at Trans-Ekulu",
    advert: "for-sale",
    propertyType: "Land",
    location: "Close to Police Barracks",
    city: "Enugu",
    state: "Enugu",
    description:
      "1 plot of land in a developed residential neighborhood, perfect for a duplex.",
    noOfUnits: "N/A",
    bedroom: null,
    bathroom: null,
    toilets: null,
    totalArea: "500 sqm",
    propertyUse: "Residential",
    yearBuilt: "N/A",
    marketStatus: "Available",
    price: 6000000,
    dateAdded: "08-Aug-2025",
    lastUpdated: "6 days ago",
    marketer: "Diamond City Realtors",
    photos: ["/images/properties/land/land-8.jpg"],
  },
  {
    reference: "LD66789",
    title: "8 Plots of Land in Owerri",
    advert: "for-sale",
    propertyType: "Land",
    location: "World Bank Housing Estate",
    city: "Owerri",
    state: "Imo",
    description:
      "8 well-demarcated plots in a fast-developing area with good road network.",
    noOfUnits: "N/A",
    bedroom: null,
    bathroom: null,
    toilets: null,
    totalArea: "8 plots",
    propertyUse: "Residential",
    yearBuilt: "N/A",
    marketStatus: "Available",
    price: 20000000,
    dateAdded: "07-Aug-2025",
    lastUpdated: "7 days ago",
    marketer: "Sunrise Realtors",
    photos: ["/images/properties/land/land-9.jpg"],
  },
  {
    reference: "LD12893",
    title: "Commercial Land in Victoria Island",
    advert: "for-sale",
    propertyType: "Land",
    location: "Adetokunbo Ademola Street",
    city: "Victoria Island",
    state: "Lagos",
    description:
      "Prime 900sqm land in the heart of Victoria Island, perfect for office or hotel.",
    noOfUnits: "N/A",
    bedroom: null,
    bathroom: null,
    toilets: null,
    totalArea: "900 sqm",
    propertyUse: "Commercial",
    yearBuilt: "N/A",
    marketStatus: "Available",
    price: 150000000,
    dateAdded: "06-Aug-2025",
    lastUpdated: "8 days ago",
    marketer: "Prime Asset Realtors",
    photos: ["/images/properties/land/land-10.jpg"],
  },
  {
    reference: "LD22345",
    title: "4 Plots of Land in Asaba",
    advert: "for-sale",
    propertyType: "Land",
    location: "Summit Junction",
    city: "Asaba",
    state: "Delta",
    description:
      "4 plots of land on a tarred road, ideal for residential or mixed use.",
    noOfUnits: "N/A",
    bedroom: null,
    bathroom: null,
    toilets: null,
    totalArea: "4 plots",
    propertyUse: "Mixed-Use",
    yearBuilt: "N/A",
    marketStatus: "Available",
    price: 12000000,
    dateAdded: "05-Aug-2025",
    lastUpdated: "9 days ago",
    marketer: "Trust Realtors Ltd",
    photos: ["/images/properties/land/land-11.jpg"],
  },
  {
    reference: "LD87654",
    title: "30 Acres of Land in Minna",
    advert: "for-sale",
    propertyType: "Land",
    location: "Along Suleja Road",
    city: "Minna",
    state: "Niger",
    description:
      "30 acres of dry land, suitable for residential estate development.",
    noOfUnits: "N/A",
    bedroom: null,
    bathroom: null,
    toilets: null,
    totalArea: "30 acres",
    propertyUse: "Residential",
    yearBuilt: "N/A",
    marketStatus: "Available",
    price: 50000000,
    dateAdded: "04-Aug-2025",
    lastUpdated: "10 days ago",
    marketer: "Unity Homes Realtors",
    photos: ["/images/properties/land/land-12.jpg"],
  },
  {
    reference: "LD44221",
    title: "Land at Banana Island",
    advert: "for-rent",
    propertyType: "Land",
    location: "Banana Island Road",
    city: "Ikoyi",
    state: "Lagos",
    description:
      "Luxury 2000sqm waterfront land in Banana Island, premium location.",
    noOfUnits: "N/A",
    bedroom: null,
    bathroom: null,
    toilets: null,
    totalArea: "2000 sqm",
    propertyUse: "Luxury Residential",
    yearBuilt: "N/A",
    marketStatus: "Available",
    price: 6000000,
    dateAdded: "03-Aug-2025",
    lastUpdated: "11 days ago",
    marketer: "Elite Realty Group",
    photos: ["/images/properties/land/land-13.jpg"],
  },
  {
    reference: "LD88231",
    title: "15 Acres of Fenced Land in Ibadan",
    advert: "for-rent",
    propertyType: "Land",
    location: "Moniya, Iseyin Road",
    city: "Ibadan",
    state: "Oyo",
    description:
      "15 acres of fenced dry land with access road, suitable for farming or small estate development.",
    noOfUnits: "N/A",
    bedroom: null,
    bathroom: null,
    toilets: null,
    totalArea: "15 acres",
    propertyUse: "Mixed Use",
    yearBuilt: "N/A",
    marketStatus: "Available",
    price: 450000,
    dateAdded: "10-Aug-2025",
    lastUpdated: "6 days ago",
    marketer: "Prime Lands & Homes",
    photos: ["images/properties/land/land-14.jpg"],
  },
  {
    reference: "LD99245",
    title: "3 Plots of Land Near GRA, Benin",
    advert: "for-rent",
    propertyType: "Land",
    location: "Boundary Road Extension",
    city: "Benin City",
    state: "Edo",
    description:
      "3 plots of dry land in a developed neighborhood, close to GRA. Perfect for residential development.",
    noOfUnits: "N/A",
    bedroom: null,
    bathroom: null,
    toilets: null,
    totalArea: "3 plots",
    propertyUse: "Residential",
    yearBuilt: "N/A",
    marketStatus: "Available",
    price: 150000,
    dateAdded: "05-Aug-2025",
    lastUpdated: "11 days ago",
    marketer: "BrightFuture Realty",
    photos: ["images/properties/land/land-15.jpg"],
  },
  {
    reference: "FT20234",
    title: "2-Bedroom Flat in Surulere, Lagos",
    advert: "for-rent",
    propertyType: "Flat",
    location: "10, Ogunlana Drive",
    city: "Lagos",
    state: "Lagos",
    description:
      "Modern 2-bedroom flat with spacious living room, POP ceiling, and constant water supply.",
    noOfUnits: "4",
    bedroom: "2",
    bathroom: "2",
    toilets: "3",
    totalArea: null,
    propertyUse: "Residential",
    yearBuilt: "2020",
    marketStatus: "Available",
    price: 1200000,
    dateAdded: "08-Aug-2025",
    lastUpdated: "8 days ago",
    marketer: "Elite Homes Agency",
    photos: [
      "/images/properties/house/house-14.jpg",
      "/images/properties/house/house-14-1.jpg",
      "/images/properties/house/house-14-2.jpg",
      "/images/properties/house/house-14-3.jpg",
      "/images/properties/house/house-14-4.jpg",
      "/images/properties/bathroom/bathroom-14.jpg",
      "/images/properties/toilet/toilet-14.jpg",
    ],
  },
  {
    reference: "DP65491",
    title: "4-Bedroom Duplex in Lekki Phase 1",
    advert: "for-sale",
    propertyType: "Duplex",
    location: "Admiralty Way",
    city: "Lagos",
    state: "Lagos",
    description:
      "Exquisite 4-bedroom duplex with fitted kitchen, BQ, ample parking, and security gatehouse.",
    noOfUnits: "1",
    bedroom: "4",
    bathroom: "5",
    toilets: "6",
    totalArea: null,
    propertyUse: "Residential",
    yearBuilt: "2022",
    marketStatus: "Available",
    price: 95000000,
    dateAdded: "12-Aug-2025",
    lastUpdated: "4 days ago",
    marketer: "Prestige Realtors Ltd",
    photos: [
      "/images/properties/house/house-15.jpg",
      "/images/properties/house/house-15-1.jpg",
      "/images/properties/house/house-15-2.jpg",
      "/images/properties/house/house-15-3.jpg",
      "/images/properties/house/house-15-4.jpg",
      "/images/properties/bathroom/bathroom-15.jpg",
      "/images/properties/toilet/toilet-15.jpg",
    ],
  }
];

export default properties;
